import './theme_meneva.scss';
import ITheme from '../ITheme';
import NavigationItems from '@/navigationItems';

export default class ThemeMeneva implements ITheme {
    id: string = 'meneva';
    matchIfHostNameContainsAny: string[] = ['verna.', 'meneva.']
    name: string = 'Menevä';
    cssClassName: string = 'theme_meneva';
    dark: boolean = false;
    menuDark: boolean = false;
    toolbarDark: boolean = true;
    bottomNavDark: boolean = true;
    menuRight: boolean = false;
    booking: boolean = true;
    menuNavigationItems: INavigationItem[] = [
        NavigationItems.passengers,
        NavigationItems.trips,
        NavigationItems.cancelTrips,
        NavigationItems.booking,
        NavigationItems.personalInfo,
        NavigationItems.messages,
        NavigationItems.register,
        NavigationItems.accessibilityReport,
        NavigationItems.privacy,
    ];
    bottomNavNavigationItems: INavigationItem[] = [
        NavigationItems.booking,
        NavigationItems.trips,
        NavigationItems.cancelTrips,
        NavigationItems.messages,
    ];
    vuetifyTheme: any = {
        primary: '#006643',
        secondary: '#00ae65',
        accent: '#00ae65',
        warning: '#eeda36',
        error: '#ff6666',
        bottomNavColor: '#ffffff',
    };
}
